import { render, staticRenderFns } from "./OnlineWalletComponentEditor.vue?vue&type=template&id=4c8ac56b&scoped=true"
import script from "./OnlineWalletComponentEditor.vue?vue&type=script&lang=js"
export * from "./OnlineWalletComponentEditor.vue?vue&type=script&lang=js"
import style0 from "./OnlineWalletComponentEditor.vue?vue&type=style&index=0&id=4c8ac56b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8ac56b",
  null
  
)

export default component.exports